import React from "react";
import PropTypes from "prop-types";
import { Icon } from "@qgiv/core-react";
import ModalStateContext from "../../ModalStateContext";
import "./NoResults.scss";

const NoResults = ({
    createTeamButtonLabel,
    displayCreateNewTeam = false,
    noSearchResultsLabel,
    noTeamsLabel,
}) => {
    const { toggleActiveView, searchTerm } =
        React.useContext(ModalStateContext);
    return (
        <div className="col col--12 col--no-left-gutter team-modal-no-results">
            {searchTerm === "" && (
                <Icon type="FontAwesome" glyph="users-duotone" />
            )}

            <p>
                {searchTerm === "" ? noTeamsLabel : noSearchResultsLabel}
                <br />
                {displayCreateNewTeam && (
                    <button
                        type="button"
                        className="-color--theme-primary -cursor--pointer"
                        onClick={(e) => {
                            e.preventDefault();
                            toggleActiveView();
                        }}
                    >
                        <strong>{createTeamButtonLabel}</strong>
                    </button>
                )}
            </p>
        </div>
    );
};

NoResults.propTypes = {
    createTeamButtonLabel: PropTypes.string.isRequired,
    displayCreateNewTeam: PropTypes.bool.isRequired,
    noSearchResultsLabel: PropTypes.string.isRequired,
    noTeamsLabel: PropTypes.string.isRequired,
};

export default NoResults;
